<div class="container-sm px-alt-3 main-container">
    <div class="search-component py-2">
        <div class="search-container">
            <input class="ihost-control" [(ngModel)]="search" name="search" type="search"
                placeholder="{{ 'sources.placeholders.search' | translate }}">
            <button (click)="clearSearch()" class="btn-clear" type="button">&times;</button>
        </div>
        <a class="btn btn-sm btn-main px-2 ms-2" (click)="showAddModal()">
            {{ 'common.buttons.addNew' | translate }}
        </a>
    </div>
</div>

<div class="container-sm mt-3 pb-5">
    <table class="list-table-item">
        <tbody
            *ngFor="let item of data | searchPipe:search:['companyTitle', 'contactSurname', 'contactMail', 'contactName']">
            <tr>
                <td>
                    <h6>{{item.companyTitle}}
                        <span
                            *ngIf="(item.companyTitle != null && item.companyTitle != '') && (item.contactSurname != null && item.contactSurname != '')">-</span>
                        <span class="text-sm"> {{item.contactSurname}} {{item.contactName}}</span>
                    </h6>
                    <p class="text-sm"
                        *ngIf="(item.contactMail != null && item.contactMail != '') || (item.contactTelephone != null && item.contactTelephone != '')">
                        <a class="text-link-faded me-2" [href]="'mailto:' + item.contactMail">{{item.contactMail}}</a>
                        <a class="text-link-faded" [href]="'tel:' + item.contactTelephone">{{item.contactTelephone}}</a>
                    </p>
                </td>
                <td class="td-actions w-1p text-nowrap">
                    <app-dotted-dropdown [context]="item" [actions]="actions"></app-dotted-dropdown>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<app-source-modal #modal [selectedTag]="selectedTag" (onClose)="modalClosed($event)"></app-source-modal>

<app-modal-dialog #deleteModal title="{{ 'sources.delete' | translate }}" modalId="delete-dietary-tag-modal"
    okText="{{ 'common.buttons.delete' | translate }}" (onClose)="deleteModalClosed($event)">
    <p>{{ 'common.info.delete' | translate }}</p>
</app-modal-dialog>